import { motion } from "framer-motion";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { PROJECTS } from "../../data/content";

export const Projects = () => {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative bg-[#09090b] py-24 lg:py-36"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <span className="text-[#e85d04] text-xs font-bold tracking-[0.28em] uppercase">
                Featured Projects
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4">
                On the water,
                <br className="hidden sm:block" /> in the field.
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.12}>
              <motion.div
                data-testid={`project-card-${i}`}
                whileHover={{ y: -8 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="group relative h-[440px] lg:h-[560px] rounded-3xl overflow-hidden cursor-pointer"
              >
                <img
                  src={p.img}
                  alt={p.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#09090b] via-[#09090b]/30 to-transparent" />
                <div className="absolute top-5 right-5 h-11 w-11 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 group-hover:rotate-45">
                  <ArrowUpRight size={20} className="text-white" />
                </div>
                <div className="relative h-full flex flex-col justify-end p-7">
                  <div className="flex items-center gap-2 text-[#e85d04] text-xs font-semibold tracking-[0.15em] uppercase mb-3">
                    <MapPin size={14} />
                    {p.location}
                  </div>
                  <h3 className="font-display font-bold text-white text-2xl lg:text-3xl leading-tight">
                    {p.title}
                  </h3>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
